import { render, staticRenderFns } from "./kisiekle.vue?vue&type=template&id=3b04d9a2&"
import script from "./kisiekle.vue?vue&type=script&lang=js&"
export * from "./kisiekle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports